/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAgentPermissionsResponse } from '../../models/get-agent-permissions-response';

export interface GetCompanyProductPermissions$Params {

/**
 * ID spoločnosti
 */
  id: number;
}

export function getCompanyProductPermissions(http: HttpClient, rootUrl: string, params: GetCompanyProductPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAgentPermissionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getCompanyProductPermissions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAgentPermissionsResponse>;
    })
  );
}

getCompanyProductPermissions.PATH = '/admin/companies/{id}/product';
